
import { supabase } from "@/integrations/supabase/client";
import type { AssetClassification } from "@/types/classifications";
import { logger } from "@/services/LoggingService";
import { convertToClassificationNode } from "../utils/nodeConverters";

export const fetchClassifications = async () => {
  const { data, error } = await supabase
    .from('asset_classifications')
    .select('*')
    .order('version', { ascending: false });

  if (error) {
    logger.error('classifications.fetch', 'Failed to fetch classifications', {
      error: error.message,
      details: error,
      timestamp: new Date().toISOString()
    });
    throw error;
  }

  return data.map(item => ({
    ...item,
    classification: convertToClassificationNode(item.classification)
  })) as AssetClassification[];
};
